import { render } from "./TableClient.vue?vue&type=template&id=6e1ac8be"
import script from "./TableClient.vue?vue&type=script&lang=js"
export * from "./TableClient.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__